import { render } from "./Project.vue?vue&type=template&id=508d7358&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=508d7358&scoped=true&lang=scss"

import exportComponent from "/Users/devgroup/work/hanbyul/hanbyeol/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508d7358"]])

export default __exports__